var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.999 9.292C2.839 4.032 7.538 0 13 0c6.065 0 11 4.935 11 11s-4.935 11-11 11a.5.5 0 010-1c5.514 0 10-4.486 10-10S18.514 1 13 1C8.083 1 3.842 4.583 3.008 9.285l1.138-1.139a.502.502 0 01.708.708l-2 2a.502.502 0 01-.708 0l-2-2a.502.502 0 01.708-.708l1.145 1.146zm14.822 6.591a.5.5 0 01-.704-.061l-4-4.762a.498.498 0 01-.117-.322V5.5a.5.5 0 111 0v5.056l3.883 4.622a.5.5 0 01-.061.705z",
    fill: "#02BD9C"
  })));
}
SvgHistory.displayName = 'History';
export default SvgHistory;